<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Weight
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.weight_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.weight_comment[index] }} <br> <br>
            </span>
        </div>  <br>  <br>  <br>
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
            contents:[
                {
                    question:"Are you lifting heavy objects on a daily basis?",
                    parts: ['Back', 'Neck']
                },
                {
                    question:"Are the weights above 30kg?",
                    parts: ['Back', 'Neck']
                },
                {
                    question:"Is there any walking involved with object lifting? (prolonged walking 30 mins or more)",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
  
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.weight_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>


